<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <customer-select-input-widget @select="onCustomerSelect" :model="searchModel" :label="false" is-search
                                            :options="{placeholder: $t('Customer')}" attribute="customer_uuid"/>
            </div>
            <div class="input-wrapper">
              <user-select-input-widget @select="onSpecialistSelect"
                                        :model="searchModel"
                                        :label="false"
                                        :options="{placeholder: $t('Specialist')}"
                                        attribute="specialist_uuid" is-search/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="created_at"
                            type="datepicker"/>
            </div>
            <div class="input-wrapper">
              <temporary-item-progress-select-input-widget attribute="progress" :model="searchModel" :label="false"/>
            </div>
            <div class="input-wrapper">
              <temporary-item-potential-select-input-widget attribute="potential" :model="searchModel" :label="false"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import CustomerSelectInputWidget from "@/core/widgets/CustomerSelectInputWidget";
  import UserSelectInputWidget from "../../../core/widgets/UserSelectInputWidget.vue";
  import TemporaryItemProgressSelectInputWidget from "../../../core/widgets/TemporaryItemProgressSelectInputWidget.vue";
  import TemporaryItemPotentialSelectInputWidget
    from "../../../core/widgets/TemporaryItemPotentialSelectInputWidget.vue";

  const {mapActions, mapState} = createNamespacedHelpers('temporaryItems');

  export default {
    name: "TemporaryItemsSearch",
    components: {
      TemporaryItemPotentialSelectInputWidget,
      TemporaryItemProgressSelectInputWidget, UserSelectInputWidget, CustomerSelectInputWidget, InputWidget},
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
      async onCustomerSelect(customer) {
        this.updateSearchModel({customer});
      },
      async onSpecialistSelect(specialist) {
        this.updateSearchModel({specialist});
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
